import { render, staticRenderFns } from "./ImageArea.vue?vue&type=template&id=ed7323e6&scoped=true&"
import script from "./ImageArea.vue?vue&type=script&lang=js&"
export * from "./ImageArea.vue?vue&type=script&lang=js&"
import style0 from "./ImageArea.vue?vue&type=style&index=0&id=ed7323e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7323e6",
  null
  
)

export default component.exports